module.exports = __webpack_public_path__ + "img/chart.d8600987.svg";